import { Button } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";

var SkipButton = function SkipButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "SkipButton",
    "data-source-file": "skip-button.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Button, {
        variant: "text",
        sx: {
          color: function color(t) {
            return t.palette.neutral.light;
          },
          mt: 2,
          mx: 'auto'
        },
        onClick: onClick,
        children: t('Skip for now')
      });
    }
  });
};

export default SkipButton;